import { useEffect, useState } from 'react';

import { useEncrypt } from '../../../hooks/useEncryptLink';
import { EventService } from '../../../Services/EventService';
import { BsCheckCircle } from 'react-icons/bs';
import { Employee, LinkEmployeeRegister } from '../../../models/employeeType';
import { IFilterEmployee } from '../../../Interfaces/interfaces';
import { DialogInfo } from '../../../component/Funcionarios/CadastroPeloLink/Dialog/DialogInfo';
import { InfoEventCompany } from '../../../models/eventType';
import { TypeLinkRegister } from '../../../enum/enums';
import { Paper } from '@mui/material';
import FormStepper from '../../../component/Funcionarios/CadastroPeloLink/FormStepperComponent';


interface IEvent {
    eventId: number,
    name: string,
    initialDate: Date | undefined,
    finalDate: Date | undefined,
}

const LinkCredenciamento = () => {
    const service = new EventService();
    const { decrypt } = useEncrypt();
    const [evento, setEvento] = useState<IEvent>();
    const [urlParams] = useState<LinkEmployeeRegister | null>(() => {
        try {
            const token = decodeURIComponent(window.location.href.split("/").pop() ?? '');
            const params: LinkEmployeeRegister = JSON.parse(decrypt(token));

            if (!params || !(params.eventId > 0))
                return null;

            if (params.typeLink === TypeLinkRegister.AtualizarFoto && !((params.employeeId ?? 0) > 0))
                return null;

            return params;
        } catch {
            return null;
        }
    });
    const [employees, setEmployees] = useState<Employee[]>([]);
    const [infoEventCompany, setInfoEventCompany] = useState<InfoEventCompany>();
    const [finish, setFinish] = useState(false);

    const isUpdatePhoto = urlParams?.typeLink === TypeLinkRegister.AtualizarFoto;

    const fetchData = async () => {
        if (urlParams === null) return;

        if (isUpdatePhoto) {
            service.getEvent(urlParams.eventId).then(setEvento);
            return;
        }

        const filter: IFilterEmployee = {
            eventId: urlParams.eventId,
            fullName: '',
            cpf: '',
            companyId: urlParams.companyId
        }

        Promise.all([
            service.getEvent(urlParams.eventId),
            service.getEmployees(filter),
            service.getEventCompanyAsync(urlParams.eventId, urlParams.companyId)
        ]).then(([event, employees, infoEvento]) => {
            setEvento(event);
            setEmployees(employees);
            setInfoEventCompany(infoEvento);
        });
    }

    const reloadTable = async () => {
        // await fetchEmployees();
    }

    // const fetchEmployees = async () => {
    //     let employees = await service.getEmployees(filter);
    //     setEmployees(employees);
    // }

    useEffect(() => {
        fetchData();
    }, []);

    if (urlParams === null) {
        return (
            <div className="flex justify-center items-center px-4 h-full" style={{ background: '#003958' }}>
                <Paper elevation={10} className='bg-white container h-[400px] rounded flex justify-center items-center text-red-600'
                    style={{ fontSize: '1.5rem', padding: '20px' }}>
                    Link inválido
                </Paper>
            </div>
        )
    }

    return (
        <>
            {!finish ? (
                <div className='p-0 flex mx-10 align-top mt-5'>
                    {!isUpdatePhoto && infoEventCompany && (<DialogInfo
                        nameEvent={infoEventCompany.eventName}
                        qtdEmployees={infoEventCompany.maxEmployeeAllowd}
                        nameCompany={infoEventCompany.companyName}
                        photoIsRequired={infoEventCompany.photoIsRequired}
                        typeLink={urlParams.typeLink}
                    />
                    )}
                    {evento && (
                        <div className='flex flex-col w-full gap-3'>
                            {(urlParams.typeLink == TypeLinkRegister.LinkUnico || isUpdatePhoto) && (
                                <FormStepper
                                    eventId={evento.eventId}
                                    companyId={urlParams.companyId}
                                    employeeId={urlParams.employeeId}
                                    typeLink={urlParams.typeLink}
                                    reloadTable={reloadTable}
                                    setFinish={setFinish}
                                />
                            )}
                        </div>
                    )}
                </div>
            ) : (
                <div className="flex justify-center items-center px-4 h-full" style={{
                    background: '#003958'
                }}>
                    <Paper elevation={10} className='bg-white container h-[400px] rounded flex justify-center items-center text-green-600' style={{
                        fontSize: '1.5rem',
                        padding: '20px',
                    }}>
                        {isUpdatePhoto ? 'FOTO ATUALIZADA COM SUCESSO !' : 'CADASTRO FINALIZADO COM SUCESSO !'}
                        <BsCheckCircle style={{
                            marginLeft: '10px',
                            fontSize: '30px'
                        }} />
                    </Paper>
                </div>
            )}
        </>
    )
}

export default LinkCredenciamento;
